import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'

Vue.use(Router)

export default new Router({
    linkActiveClass: 'router-link-active',
    mode: 'hash',
   
    routes: [{
            path: '/',
            name: 'Index',
            component: Index,
            children: [{
                    path: '',
                    component: () =>
                        import ('@/components/main/main')
                },
                {
                    path: '/about/:id',
                    component: () =>
                        import ('@/components/about/about'),
                    props: true
                },
                {
                    path: '/logistics/:id',
                    component: () =>
                        import ('@/components/logistics/logistics'),
                    props: true
                },
                {
                    path: '/business/:id',
                    component: () =>
                        import ('@/components/business/business'),
                    props: true
                },
                {
                    path: '/solve/:id',
                    component: () =>
                        import ('@/components/solve/solve'),
                    props: true
                },
                {
                    path: '/case',
                    name: 'case',
                    component: () =>
                        import ('@/components/case/case'),
                        props: true
                },
                {
                    path: '/fnews/:id',
                    component: () =>
                        import ('@/components/fnews/fnews'),
                    props: true
                },
                {
                    path: '/recruit/:id',
                    component: () =>
                        import ('@/components/recruit/recruit'),
                    props: true
                },
                {
                    path: '/contactUs/:id',
                    component: () =>
                        import ('@/components/contactUs/contactUs'),
                    props: true
                }
            ]
        },
        // {
        //   path: '*',
        //   redirect: '/'
        // },
        {
            path: '/news/:id',
            name: 'News',
            component: () =>
                import ('@/components/news/newsDetail'),
                props: true
        },
        {
            path: '/jobs/:id',
            name: 'jobs',
            component: () =>
                import ('@/components/recruit/jobDetail'),
                props: true
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
      }
})


// WEBPACK FOOTER //
// ./src/router/index.js